import {IconButton, Menu, MenuItem, Tooltip} from "@mui/material";
import StarsIcon from '@mui/icons-material/Stars';
import {memo, useState} from "react";
import {useTheme} from "@mui/material/styles";

const MhdIconMenu = ({ label, value, onChange, choices }) => {
  const theme = useTheme()
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{
          sx: {
            borderRadius: '4px',
            width: '180px',
            // padding: 1
          },
        }}
        MenuListProps={{
          sx: {
            backgroundColor: 'background',
          },
        }}
      >
        {choices.map((choice) => (
          <MenuItem
            key={choice.value}
            value={choice.value}
            onClick={() => onChange(choice.value)}
          >
            {choice.label}
          </MenuItem>
        ))}
      </Menu>

      <Tooltip title={label} arrow>
        <IconButton
          onClick={(e) => setAnchor(e.currentTarget)}
          color={'primary'}
        >
          <StarsIcon fontSize={'medium'} />
        </IconButton>
      </Tooltip>
      </>
  );
};

export default memo(MhdIconMenu);